export default {
  computed: {
    currentLocale() {
      return this.$i18n.locales.filter(i => i.code === this.$i18n.locale).pop()
    },
    locale() {
      return this.$i18n.locale
    }
  }
}
